import React from 'react';
import { Box, Typography, TextField, Button, InputAdornment } from '@mui/material';

const View360Tab = ({ view360Url, onUrlChange, loadingProperty }) => {
  const handleUrlChange = (event) => {
    const value = event.target.value;
    onUrlChange(value);
  };

  const handleClearUrl = () => {
    onUrlChange('');
  };

  const handleViewImage = () => {
    if (view360Url) {
      window.open(view360Url, '_blank', 'noopener,noreferrer');
    }
  };

  const canViewImage = !!view360Url;

  return (
    <Box sx={{ p: 2 }}>
      <Typography variant="subtitle1" sx={{ mb: 2, fontWeight: 'bold' }}>
        360 View 
      </Typography>

      <TextField
        fullWidth
        label="360 Image URL"
        variant="outlined"
        value={view360Url || ''}
        onChange={handleUrlChange}
        placeholder="https://example.com/360-image.jpg"
        sx={{ mb: 2 }}
        disabled={loadingProperty}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <Button
                variant="contained"
                onClick={handleViewImage}
                disabled={!canViewImage || loadingProperty}
                size="small"
                sx={{ minWidth: 'auto' }}
              >
                View Image
              </Button>
            </InputAdornment>
          ),
        }}
      />

      <Box sx={{ display: 'flex', gap: 1, mb: 3 }}>
        <Button
          variant="outlined"
          onClick={handleClearUrl}
          disabled={!view360Url || loadingProperty}
        >
          Clear
        </Button>
      </Box>
    </Box>
  );
};

export default View360Tab;